import {EntityData, identifier} from "@fedeltapointofsale/data-client";

export class ProductBarcodeData extends EntityData<ProductBarcodeData> {
    @identifier productBarcodeId: number;
}
